import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  throw new Error(
    'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set. `npm run env:sync` writes apps/dashboard/.env.local from the root .env.local.',
  );
}

/**
 * The Postgres schema holding the application tables. They live in `nestmatch`,
 * not `public`, so that ours are distinguishable from Supabase's ~80 extension
 * tables. PostgREST must also have it exposed: Supabase -> Project Settings ->
 * API -> Exposed schemas. Both apps must agree on this name.
 */
const SCHEMA = 'nestmatch';

/**
 * Browser client. Every read and write goes through RLS, which allows rows only
 * to an authenticated email present in `app_allowlist`. There is no privileged
 * path in this app on purpose - the dashboard cannot post anything anywhere.
 *
 * The session is not created here. `signIn` in lib/brain.ts posts the username and
 * password to the Worker, and stores what it answers with `setSession`; so there are no
 * magic-link tokens to look for in the URL either, which is what `detectSessionInUrl: false`
 * says.
 */
export const supabase = createClient(url, anonKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
  db: { schema: SCHEMA },
});
